export default "__VITE_ASSET__BLnNRVh5__"